import React from 'react';

const Bike: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.505"
      d="M21.37 84.006h43.62M26.6 27.476l6.238 16.014m38.428-18.477L60.643 57.606m4.83-32.432H80.32L84.264 16M35.455 27.63H15.98m22.936 38.873l6.881 7.565m-6.236.442h12.796M35.856 55.882a5.753 5.753 0 11-3.868 1.685 5.754 5.754 0 014.07-1.685h-.202zm.202-12.075a19.878 19.878 0 0113.279 4.909c2.334 2.012 15.693 13.4 16.578 14.204a9.015 9.015 0 010 13.52 10.783 10.783 0 01-7.323 2.777H36.058a19.837 19.837 0 01-13.56-5.191 16.618 16.618 0 010-24.948 19.837 19.837 0 0113.56-5.19v-.081z"
    ></path>
  </svg>
);

export default Bike;
